import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getTalents } from '@libs/api/talents';
import { DateRangeShortcutsItem } from '@libs/models/common';
import { dateRangeShortcuts } from '@libs/models/common';
import { createDefaultFilterSlice, DefaultFilterState } from '../../filters';
import { StaffListItem } from '@libs/models/talents/talent';

type ShiftFilterState = {
  dateRangeShortcuts: DateRangeShortcutsItem[];
  loading: boolean;
  filterProviders: StaffListItem[];
  loadData: (options: { locationId: string }) => Promise<void>;
  loadProvidersFiltersData: (options: { locationId?: string; searchTerm?: string }) => Promise<void>;
};
export const useShiftsFilter = create<DefaultFilterState & ShiftFilterState>()(
  persist(
    (set, get, store) => ({
      ...createDefaultFilterSlice(set, get, store),
      dateRangeShortcuts: dateRangeShortcuts,
      loading: false,
      filterProviders: [],

      loadData: async ({ locationId }) => {
        set({
          loading: true,
        });

        try {
          const { items: talents } = await getTalents({
            filters: {
              statuses: {
                key: 'statuses',
                value: ['Active'],
              },
              locations: {
                key: 'locations',
                value: [locationId],
              },
            },
            page: -1,
            size: -1,
          });
          set({
            filterProviders: talents,
            loading: false,
          });
        } catch (error) {
          set({
            loading: false,
          });
          throw error;
        }
      },
      loadProvidersFiltersData: async ({ locationId, searchTerm = '' }) => {
        set({
          loading: true,
        });
        try {
          const { items: talents } = await getTalents({
            filters: {
              statuses: {
                key: 'statuses',
                value: ['Active'],
              },
              ...(locationId
                ? {
                    locations: {
                      key: 'locations',
                      value: [locationId],
                    },
                  }
                : {}),
            },
            search: searchTerm,
            page: -1,
            size: -1,
          });

          set({
            filterProviders: talents,
            loading: false,
          });
        } catch (error) {
          set({
            loading: false,
          });
          throw error;
        }
      },
    }),
    {
      name: 'userdata:shiftsList',
      partialize: (state) =>
        Object.keys(state)
          .filter((key) => !['dateRangeShortcuts', 'loading', 'filterProviders'].includes(key))
          .reduce((acc, key) => ({ ...acc, [key]: (state as any)[key] }), {}),
    },
  ),
);
